<ui-dialog
    size="small"
    [isCloseable]="false"
    header="{{ 'employees.compensation.retroactivelyCreateCompensation' | translate }}"
    [scrollable]="true"
    (primaryButtonPressed)="onSave(); showBackDatedModal = false"
    [primaryButtonLabel]="'yesConfirm' | translate"
    [open]="showBackDatedModal"
    [secondaryButtonLabel]="'cancel' | translate"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="showBackDatedModal = false"
    (closing)="showBackDatedModal = false"
>
    <p>
        {{ selectedBackDatedPeriodMessage | appTranslate }}&nbsp;{{
            'employees.compensation.confirmRetroactivelyCreate' | translate
        }}
    </p>
    <ui-banner variant="bulb">
        <p>
            <span [innerHTML]="'employees.compensation.ifYouUnderPaid' | translate"></span>&nbsp;
            <span [innerHTML]="'employees.compensation.ifYouOverPaid' | translate"></span>
        </p>
    </ui-banner>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [back]="true" title="{{ 'employees.compensation.createCompensation' | translate }}"></app-header>
    <p>
        {{ 'employees.compensation.specifyTheDetailsForDifferentTypesOfPayments' | translate }}
        <a href="{{ '4410171761303' | i18nHelpCentre }}" target="_blank">{{
            'employees.compensation.learnMoreAboutCompensations' | translate
        }}</a>
    </p>
    <app-primary-compensation-form
        #primaryCompensationForm
        [employee]="employee"
        [salary]="salary"
        (disabledSaveButtonEmitter)="handleSaveButtonDisable($event)"
        (displayVacationPayInCompensationHistoryTable)="handleDisplayVacationPayInCompensationHistoryTable($event)"
    ></app-primary-compensation-form>
    <app-table
        *ngIf="displayCompensationTable"
        [useStickyHeader]="false"
        [table]="table"
        [showSearch]="false"
        title="{{ 'employees.compensation.compensationHistory' | translate }}"
        class="table margin-top-3"
    >
        <app-empty-state
            [label]="
                !table.hasFiltersApplied()
                    ? ('employees.compensation.thereAreNoCompensationsToDisplay' | translate)
                    : ''
            "
            src="/assets/illustrations/piggy-bank.png"
        ></app-empty-state>
    </app-table>
    <div class="flex justify-end">
        <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | translate }} </ui-button>
        <ui-button
            class="padding-left-1"
            [disabled]="disableSaveButton"
            type="primary"
            (click)="handleCompensationCreate()"
            >{{ 'save' | translate }}
        </ui-button>
    </div>
</div>
